// DS: i4.37
import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import IconWrap from '../../IconWrap';
const Sale = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props, {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 4.00002V12L18.4 12V13.6L16.8 13.6V15.2L15.2 15.2V16.8L13.6 16.8V18.4L12 18.4V20H10.4L10.4 18.4H8.8L8.8 16.8H7.2L7.2 15.2H5.6L5.6 13.6H4V12H5.6L5.6 10.4H7.2L7.2 8.8H8.8L8.8 7.2H10.4L10.4 5.6H12L12 4L20 4.00002ZM15.2 6.4L17.6 6.4V8.8L15.2 8.8L15.2 6.4Z"
    })));
Sale.displayName = 'Sale';
export default Sale;
